export default __webpack_public_path__ + "static/4-418e4fd1fe352e4853ef70e2a24c53e9.jpeg";